module.exports = __webpack_public_path__ + "static/media/VectorPointInacabado2.474e39ae.svg";